import { render } from "./Users.vue?vue&type=template&id=0a6dacb7&scoped=true&ts=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=0a6dacb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6dacb7"]])

export default __exports__